export default {
      id: "ic-misc-moins-usage",
      viewBox: "0 0 18 2",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#ic-misc-moins-usage",
      toString: function () {
        return this.url;
      }
    }